/*
 * Coveted Lists (Forge Ops, 2026-10-02). Hearts on product cards and product pages, the header count, the
 * choose-lists panel, and the My Coveted Lists / shared list pages served at /apps/covetedlist.
 * Source: coveted-forge\theme-fixes\covet\cf-lists.js. Server: forge-ops\src\routes\lists.ts.
 *
 * Page views never call the server: hearts are drawn from this browser's copy. Clicks queue changes and send
 * them in a batch; if Forge Ops is unreachable they wait here and go later. A signed-in shopper's lists are
 * re-read once per browser session.
 */
(function () {
  'use strict';
  if (window.CFCovet && window.CFCovet.loaded) return;

  var BASE = '/apps/covetedlist';
  var LIKED = 'liked';
  var TIERS = [[100, 'BULK10', 10], [250, 'BULK15', 15], [500, 'BULK20', 20], [1000, 'ARMY25', 25]];
  var HEART = '<svg class="cf-h" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.6 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.4 0 5.5 3.5 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  var cfg = window.CFCovetConfig || {};
  var pageEl = document.getElementById('cf-lists-page');
  var cid = cfg.cid ? String(cfg.cid) : (pageEl && pageEl.getAttribute('data-customer')) || '';

  // ------------------------------------------------------------ storage (every access may throw: private mode)
  function lsGet(k) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* not kept; still works this page */ } }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) { /* nothing to do */ } }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* nothing to do */ } }

  function randomKey(n) {
    var a = new Uint8Array(n), s = '', abc = 'abcdefghijklmnopqrstuvwxyz0123456789';
    (window.crypto || window.msCrypto).getRandomValues(a);
    for (var i = 0; i < n; i++) s += abc[a[i] % abc.length];
    return s;
  }
  function guestToken(create) {
    var t = lsGet('cf-covet-guest');
    if (!t && create) { t = 'g' + randomKey(31); lsSet('cf-covet-guest', t); }
    return t;
  }
  function who() { return cid ? { as: 'customer', cid: cid } : { as: 'guest', guest: guestToken(true) }; }

  var KEY = 'cf-covet:' + (cid ? 'c' + cid : 'g');
  var state = lsGet(KEY) || { lists: [], items: [], prod: {} };
  state.prod = state.prod || {};
  function ensureLiked() {
    if (!state.lists.some(function (l) { return l.k === LIKED; })) state.lists.unshift({ k: LIKED, n: 'Liked', par: null, pos: 0, sh: { on: false, t: null, nm: null } });
  }
  ensureLiked();
  function save() { lsSet(KEY, state); }
  function list(k) { for (var i = 0; i < state.lists.length; i++) if (state.lists[i].k === k) return state.lists[i]; return null; }
  function topLists() { return state.lists.filter(function (l) { return !l.par; }).sort(byPos); }
  function kids(k) { return state.lists.filter(function (l) { return l.par === k; }).sort(byPos); }
  function byPos(a, b) { return a.k === LIKED ? -1 : b.k === LIKED ? 1 : (a.pos || 0) - (b.pos || 0); }
  function rowsOf(p) { return state.items.filter(function (i) { return i.p === p; }); }
  function row(l, p, v) { for (var i = 0; i < state.items.length; i++) { var x = state.items[i]; if (x.l === l && x.p === p && x.v === v) return x; } return null; }

  // ------------------------------------------------------------ changes: applied here at once, sent in batches
  var queue = lsGet('cf-covet-queue') || [];
  function op(o) {
    applyLocal(o);
    var w = who();
    var last = queue[queue.length - 1];
    if (last && last.who.as === w.as && last.who.cid === w.cid && last.who.guest === w.guest && last.ops.length < 150) last.ops.push(o);
    else queue.push({ who: w, ops: [o] });
    lsSet('cf-covet-queue', queue);
    save();
    saveState = 'saving';
    drawAll();
    setSave('saving');
    flushSoon();
  }
  function applyLocal(o) {
    var r;
    switch (o.t) {
      case 'add':
        if (!row(o.l, o.p, o.v)) state.items.unshift({ l: o.l, p: o.p, v: o.v, q: o.q || 1, n: o.n || '', a: new Date().toISOString() });
        break;
      case 'remove': state.items = state.items.filter(function (i) { return !(i.l === o.l && i.p === o.p && i.v === o.v); }); break;
      case 'removeAll': state.items = state.items.filter(function (i) { return !(i.p === o.p && (o.v === undefined || i.v === o.v)); }); break;
      case 'qty': r = row(o.l, o.p, o.v); if (r) r.q = o.q; break;
      case 'note': r = row(o.l, o.p, o.v); if (r) r.n = o.n; break;
      case 'variant':
        r = row(o.l, o.p, o.v);
        if (!r) break;
        var t = row(o.l, o.p, o.nv);
        if (t) { t.q = Math.min(999, t.q + r.q); state.items.splice(state.items.indexOf(r), 1); } else r.v = o.nv;
        break;
      case 'list':
        var l = list(o.l);
        if (l) { l.n = o.name; l.par = o.parent; } else state.lists.push({ k: o.l, n: o.name, par: o.parent, pos: state.lists.length, sh: { on: false, t: null, nm: null } });
        break;
      case 'dellist':
        state.lists.forEach(function (x) { if (x.par === o.l) x.par = null; });
        state.lists = state.lists.filter(function (x) { return x.k !== o.l; });
        state.items = state.items.filter(function (i) { return i.l !== o.l; });
        break;
    }
  }

  var flushTimer = null, flushing = null;
  function flushSoon(ms) { clearTimeout(flushTimer); flushTimer = setTimeout(flush, ms == null ? 400 : ms); }
  function post(action, body) {
    return fetch(BASE + '/api/' + action, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}), credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; }); });
  }
  /** Sends waiting batches oldest first. Resolves when the queue is empty or the server cannot be reached. */
  function flush() {
    if (flushing) return flushing;
    flushing = (function next() {
      if (!queue.length) return Promise.resolve(true);
      var b = queue[0];
      var body = { as: b.who.as, ops: b.ops };
      if (b.who.cid) body.cid = b.who.cid;
      if (b.who.guest) body.guest = b.who.guest;
      return post('ops', body).then(function (j) {
        // 409: made as someone no longer signed in here. It cannot go anywhere; drop it.
        if (j._status === 200 || j._status === 409 || j._status === 400) { queue.shift(); lsSet('cf-covet-queue', queue); return next(); }
        flushSoon(30000);
        return false;
      }, function () { flushSoon(30000); return false; });
    })().then(function (ok) { flushing = null; setSave(ok ? 'saved' : 'offline'); return ok; });
    return flushing;
  }

  /**
   * Save status (Dan 2026-10-02: "People want to be sure if they pick variations that it's persistent"). Only says
   * "Saved" once Forge Ops has confirmed every change; "Saving..." while changes are on their way; plainly
   * "Not saved yet" with Save now when it cannot reach the server (changes stay on this device and retry).
   */
  var saveState = queue.length ? 'saving' : 'saved';
  var SAVE_TEXT = { saved: '\u2713 Saved', saving: 'Saving\u2026', offline: 'Not saved yet. Retrying.' };
  function saveInner() {
    return esc(SAVE_TEXT[saveState]) + (saveState === 'offline' ? ' <button type="button" class="cf-link" data-cf-savenow>Save now</button>' : '');
  }
  function saveHtml() {
    return '<span class="cf-save" data-cf-save data-state="' + saveState + '" role="status" aria-live="polite">' + saveInner() + '</span>';
  }
  function setSave(st) {
    saveState = st;
    var els = document.querySelectorAll('[data-cf-save]');
    for (var i = 0; i < els.length; i++) { els[i].setAttribute('data-state', st); els[i].innerHTML = saveInner(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cf-savenow')) { e.preventDefault(); setSave('saving'); flush(); }
  });

  /** Signed in: re-read the lists once per browser session (the only call a page view can make). */
  function syncOnce() {
    if (!cid || ssGet('cf-covet-synced-' + cid)) return Promise.resolve();
    return flush().then(function () {
      var g = guestToken(false);
      return post('state', { guest: g || undefined });
    }).then(function (j) {
      if (!j || j._status !== 200 || j.owner !== 'customer' || String(j.cid) !== cid) return;
      replaceState(j.state);
      ssSet('cf-covet-synced-' + cid, '1');
      if (j.guestItems > 0) offerMerge(j.guestItems);
    }, function () { /* offline: the saved copy stands */ });
  }
  function replaceState(s) {
    if (!s) return;
    if (queue.length) return; // changes still on their way: keep ours until they land
    state.lists = s.lists;
    state.items = s.items;
    ensureLiked();
    save();
    drawAll();
  }

  // ------------------------------------------------------------ what a heart knows about its product
  function metaFrom(el) {
    var p = Number(el.getAttribute('data-p'));
    var m = state.prod[p] || {};
    m.t = el.getAttribute('data-t') || m.t;
    m.h = el.getAttribute('data-h') || m.h;
    m.i = el.getAttribute('data-i') || m.i;
    var pr = Number(el.getAttribute('data-pr'));
    if (pr) m.pr = pr / 100;
    state.prod[p] = m;
    return p;
  }
  /** {opts: option names, v: {variant id: its choices in the same order}} from the product page snippet. */
  function variantsOf(el) {
    var s = el.querySelector('[data-cf-variants]');
    try { var j = s ? JSON.parse(s.textContent) : null; return j && j.v ? j : { opts: [], v: {} }; } catch (e) { return { opts: [], v: {} }; }
  }
  function hasVersions(el) { return Object.keys(variantsOf(el).v).length > 1; }
  function currentVariant(el) {
    var form = document.getElementById(el.getAttribute('data-form'));
    var input = form && form.querySelector('[name="id"]');
    var v = input && Number(input.value);
    if (v) return v;
    var vs = Object.keys(variantsOf(el).v);
    return vs.length ? Number(vs[0]) : 0;
  }
  /** "Scale 32mm · Model 5x": each option's name with its choice, so "1, A" never reaches a shopper. */
  function optionLabel(names, values) {
    return (values || []).map(function (val, i) {
      var n = names && names[i];
      // "Single Model" already says Model: no "Model Single Model".
      return n && n !== 'Title' && String(val).toLowerCase().indexOf(n.toLowerCase()) < 0 ? n + ' ' + val : val;
    }).filter(function (x) { return x && x !== 'Default Title'; }).join(' \u00b7 ');
  }
  function versionName(title) { return title && title !== 'Default Title' ? title.replace(/ \/ /g, ' \u00b7 ') : ''; }

  // ------------------------------------------------------------ drawing
  function countProducts() {
    var seen = {};
    state.items.forEach(function (i) { seen[i.p] = 1; });
    return Object.keys(seen).length;
  }
  function drawAll() {
    var hearts = document.querySelectorAll('[data-cf-heart]');
    for (var i = 0; i < hearts.length; i++) {
      var h = hearts[i], p = Number(h.getAttribute('data-p')), on = rowsOf(p).length > 0;
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      h.setAttribute('aria-label', (on ? 'Saved. Change lists for ' : 'Covet ') + (h.getAttribute('data-t') || 'this'));
      h.title = on ? 'Saved' : 'Covet';
    }
    var pdps = document.querySelectorAll('[data-cf-pdp]');
    for (var k = 0; k < pdps.length; k++) drawPdp(pdps[k]);
    var n = countProducts();
    var bubbles = document.querySelectorAll('[data-cf-covet-count]');
    for (var b = 0; b < bubbles.length; b++) {
      bubbles[b].hidden = n === 0;
      var s = bubbles[b].querySelector('[aria-hidden]');
      if (s) s.textContent = n < 100 ? String(n) : '99+';
      var vh = bubbles[b].querySelector('.visually-hidden');
      if (vh) vh.textContent = n + ' saved';
    }
    var hdr = document.querySelectorAll('.header__icon--covet');
    for (var c = 0; c < hdr.length; c++) hdr[c].classList.toggle('cf-on', n > 0);
    if (pageEl && pageView) pageView.draw();
    if (panel && panelFor && panelFor.pdp) drawPanel();
  }
  /** The product page button covets the ITEM, like a card heart; a version is an optional extra in the panel. */
  function drawPdp(el) {
    var p = Number(el.getAttribute('data-p'));
    var on = rowsOf(p).length > 0;
    var btn = el.querySelector('[data-cf-covet-btn]'), label = el.querySelector('[data-cf-covet-label]');
    if (!btn || !label) return;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    label.textContent = on ? 'Coveted' : 'Covet';
  }

  // ------------------------------------------------------------ live message (toast) and the one-time tip
  var live;
  function say(html, ms) {
    if (!live) { live = document.createElement('div'); live.className = 'cf-live'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.innerHTML = html;
    clearTimeout(say.t);
    say.t = setTimeout(function () { live.innerHTML = ''; }, ms || 3500);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  // ------------------------------------------------------------ the choose-lists panel
  var panel = null, panelFor = null, panelReturn = null;
  function closePanel() {
    if (!panel) return;
    panel.remove(); panel = null; panelFor = null;
    document.removeEventListener('keydown', panelKeys, true);
    if (panelReturn) { try { panelReturn.focus(); } catch (e) { /* gone */ } panelReturn = null; }
  }
  function panelKeys(e) { if (e.key === 'Escape') { e.preventDefault(); closePanel(); } }
  /** v === null: the whole product (a card or the product page); pdp = the product page block, for its versions. */
  function openPanel(anchor, p, v, title, pdp) {
    closePanel();
    panelFor = { p: p, v: v, title: title, pdp: pdp || null };
    panelReturn = anchor;
    panel = document.createElement('div');
    panel.className = 'cf-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Choose lists');
    drawPanel();
    document.body.appendChild(panel);
    var r = anchor.getBoundingClientRect();
    var left = Math.min(window.scrollX + r.left, window.scrollX + document.documentElement.clientWidth - panel.offsetWidth - 16);
    panel.style.left = Math.max(16, left) + 'px';
    panel.style.top = (window.scrollY + r.bottom + 8) + 'px';
    document.addEventListener('keydown', panelKeys, true);
    var first = panel.querySelector('input,button');
    if (first) first.focus();
  }
  function inList(l, p, v) { return v === null ? state.items.some(function (i) { return i.l === l && i.p === p; }) : !!row(l, p, v); }
  function drawPanel() {
    if (!panel) return;
    var f = panelFor, html = '<button type="button" class="cf-close" aria-label="Close" data-cf-act="close">&times;</button>';
    html += '<h3>' + (f.v === null ? 'Saved to:' : 'Saved ' + esc(f.title || 'this version') + ' to:') + '</h3>';
    topLists().forEach(function (l) {
      html += box(l, false);
      kids(l.k).forEach(function (c) { html += box(c, true); });
    });
    if (f.pdp && hasVersions(f.pdp) && rowsOf(f.p).length) html += versionHtml(f);
    html += '<div class="cf-row" data-cf-newrow><button type="button" class="cf-btn cf-ghost cf-small" data-cf-act="new">+ New list</button>' +
      '<button type="button" class="cf-link" data-cf-act="removeAll">Remove from all lists</button></div>' +
      '<div class="cf-row cf-save-row"><a href="' + BASE + '">See my lists</a>' + saveHtml() + '</div>';
    var ae = document.activeElement, focused = ae && panel.contains(ae) ? ae.getAttribute('data-cf-act') || ae.getAttribute('data-cf-list') : null;
    panel.innerHTML = html;
    if (focused) { var back = panel.querySelector('[data-cf-act="' + focused + '"],[data-cf-list="' + focused + '"]'); if (back) back.focus(); }
    function box(l, sub) {
      return '<label' + (sub ? ' class="cf-sub"' : '') + '><input type="checkbox" data-cf-list="' + esc(l.k) + '"' + (inList(l.k, f.p, f.v) ? ' checked' : '') + '> ' + esc(l.n) + '</label>';
    }
  }
  /**
   * The panel's Version line (Dan 2026-10-02: the product page saves the version selected, "any" is the opt-out):
   * "Saved as Scale 32mm · Single Model", "Also save <the options now picked>" when they differ, and
   * "Any version instead". The button's own label never names a version.
   */
  function versionHtml(f) {
    var vd = variantsOf(f.pdp), cur = currentVariant(f.pdp);
    var saved = {};
    rowsOf(f.p).forEach(function (r) { if (r.v) saved[r.v] = 1; });
    var labels = Object.keys(saved).map(function (v) { return optionLabel(vd.opts, vd.v[v]) || 'a version no longer offered'; });
    var html = '<div class="cf-ver"><div class="cf-meta">Version</div>';
    html += '<div>' + (labels.length ? 'Saved as ' + labels.map(esc).join('; ') : 'Any version') + '</div>';
    html += '<div class="cf-row">';
    if (!saved[cur]) html += '<button type="button" class="cf-btn cf-ghost cf-small" data-cf-act="remember">' + (labels.length ? 'Also save ' : 'Save as ') + esc(optionLabel(vd.opts, vd.v[cur])) + '</button>';
    if (labels.length) html += '<button type="button" class="cf-link" data-cf-act="forget">Any version instead</button>';
    return html + '</div></div>';
  }
  /** The options picked on the page become the saved version, in every list holding the item. */
  function rememberVersion(f) {
    var cur = currentVariant(f.pdp);
    state.lists.forEach(function (l) {
      if (!inList(l.k, f.p, null) || row(l.k, f.p, cur)) return;
      if (row(l.k, f.p, 0)) op({ t: 'variant', l: l.k, p: f.p, v: 0, nv: cur });
      else op({ t: 'add', l: l.k, p: f.p, v: cur, from: 'product' });
    });
    if (!rowsOf(f.p).length) op({ t: 'add', l: LIKED, p: f.p, v: cur, from: 'product' });
  }
  /** Back to "any version": in every list holding the item, its saved versions become one "any version" row. */
  function forgetVersion(f) {
    state.lists.forEach(function (l) {
      var versioned = state.items.filter(function (i) { return i.l === l.k && i.p === f.p && i.v; });
      versioned.forEach(function (r, n) {
        if (n === 0 && !row(l.k, f.p, 0)) op({ t: 'variant', l: l.k, p: f.p, v: r.v, nv: 0 });
        else op({ t: 'remove', l: l.k, p: f.p, v: r.v });
      });
    });
  }
  /** What a save from this panel stores: the version picked on a product page, any version from a card. */
  function panelVersion(f) { return f.pdp && hasVersions(f.pdp) ? currentVariant(f.pdp) : 0; }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!panel || !panel.contains(t) || !t.hasAttribute('data-cf-list')) return;
    var l = t.getAttribute('data-cf-list'), f = panelFor;
    if (t.checked) op({ t: 'add', l: l, p: f.p, v: f.v === null ? panelVersion(f) : f.v, from: f.pdp ? 'product' : 'card' });
    else if (f.v !== null) op({ t: 'remove', l: l, p: f.p, v: f.v });
    else state.items.filter(function (i) { return i.l === l && i.p === f.p; }).forEach(function (i) { op({ t: 'remove', l: l, p: f.p, v: i.v }); });
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (panel && !panel.contains(t) && !(t.closest && t.closest('[data-cf-heart],[data-cf-covet-btn]'))) { closePanel(); }
    var act = t.closest && t.closest('[data-cf-act]');
    if (act && panel && panel.contains(act)) {
      var a = act.getAttribute('data-cf-act'), f = panelFor;
      if (a === 'close') closePanel();
      if (a === 'removeAll') { op(f.v === null ? { t: 'removeAll', p: f.p } : { t: 'removeAll', p: f.p, v: f.v }); closePanel(); say('Removed from all lists.'); }
      if (a === 'new') {
        var rowEl = panel.querySelector('[data-cf-newrow]');
        rowEl.innerHTML = '<input class="cf-input" maxlength="60" placeholder="List name" aria-label="New list name" data-cf-newname>' +
          '<button type="button" class="cf-btn cf-small" data-cf-act="create">Add</button>';
        rowEl.querySelector('input').focus();
      }
      if (a === 'create') createFromPanel();
      if (a === 'remember') { var vd = variantsOf(f.pdp); rememberVersion(f); say('Saved with ' + esc(optionLabel(vd.opts, vd.v[currentVariant(f.pdp)])) + '.'); }
      if (a === 'forget') { forgetVersion(f); say('Saved as any version. Pick one later in your list.'); }
    }
    var heart = t.closest && t.closest('[data-cf-heart]');
    if (heart) { e.preventDefault(); e.stopPropagation(); cardClick(heart); }
    var cbtn = t.closest && t.closest('[data-cf-covet-btn]');
    if (cbtn) { e.preventDefault(); pdpClick(cbtn.closest('[data-cf-pdp]'), cbtn); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-cf-newname')) { e.preventDefault(); createFromPanel(); }
  });
  function createFromPanel() {
    var input = panel && panel.querySelector('[data-cf-newname]');
    var name = input && input.value.trim();
    if (!name) return;
    if (state.lists.length >= 50) { say('You have 50 lists, the most we keep. Delete one first.'); return; }
    var k = randomKey(10), f = panelFor;
    op({ t: 'list', l: k, name: name.slice(0, 60), parent: null });
    op({ t: 'add', l: k, p: f.p, v: f.v === null ? panelVersion(f) : f.v, from: f.pdp ? 'product' : 'card' });
    drawPanel();
  }

  function cardClick(el) {
    var p = metaFrom(el), rows = rowsOf(p);
    if (!rows.length) {
      op({ t: 'add', l: LIKED, p: p, v: 0, from: 'card' });
      if (!lsGet('cf-covet-tipped')) { lsSet('cf-covet-tipped', 1); tip(el); }
      else say('Saved to Liked. <a href="' + BASE + '">See my lists</a>');
      return;
    }
    if (rows.every(function (r) { return r.l === LIKED; })) { op({ t: 'removeAll', p: p }); say('Removed from Liked.'); return; }
    openPanel(el, p, null, el.getAttribute('data-t'));
  }
  function tip(el) {
    var d = document.createElement('div');
    d.className = 'cf-tip';
    d.setAttribute('role', 'status');
    d.innerHTML = 'Saved to Liked &middot; <a href="' + BASE + '">See my lists</a>';
    var r = el.getBoundingClientRect();
    d.style.top = (window.scrollY + r.bottom + 6) + 'px';
    document.body.appendChild(d);
    d.style.left = Math.max(16, window.scrollX + r.right - d.offsetWidth) + 'px';
    setTimeout(function () { d.remove(); }, 5000);
  }
  /** Saves the item, at the version selected on the page, to Liked; the panel offers lists and "Any version instead". */
  function pdpClick(el, btn) {
    if (!el) return;
    var p = metaFrom(el);
    if (!rowsOf(p).length) op({ t: 'add', l: LIKED, p: p, v: hasVersions(el) ? currentVariant(el) : 0, from: 'product' });
    openPanel(btn, p, null, el.getAttribute('data-t'), el);
  }

  // Product pages re-draw parts of themselves when a version is picked: re-label the button after.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) setTimeout(drawAll, 60);
  });
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-cf-heart],[data-cf-pdp]') || n.querySelector('[data-cf-heart],[data-cf-pdp]'))) { clearTimeout(mo.t); mo.t = setTimeout(drawAll, 50); return; }
      }
    }
  });

  // ------------------------------------------------------------ "keep the items you saved before signing in?"
  function offerMerge(n) {
    var g = guestToken(false);
    if (!g || lsGet('cf-covet-merge-no:' + g)) return;
    var bar = document.createElement('div');
    bar.className = 'cf-merge';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Saved items');
    bar.innerHTML = '<span>You saved ' + n + ' item' + (n === 1 ? '' : 's') + ' on this device before signing in. Keep them?</span>' +
      '<button type="button" class="cf-btn cf-small" data-m="yes">Add to my lists</button><button type="button" class="cf-btn cf-ghost cf-small" data-m="no">Not now</button>';
    // Beside the lists page, never inside it: the page redraws itself.
    if (pageEl) pageEl.parentNode.insertBefore(bar, pageEl);
    else { var host = document.querySelector('main') || document.body; host.insertBefore(bar, host.firstChild); }
    bar.addEventListener('click', function (e) {
      var m = e.target.getAttribute && e.target.getAttribute('data-m');
      if (m === 'no') { lsSet('cf-covet-merge-no:' + g, 1); bar.remove(); }
      if (m === 'yes') {
        e.target.disabled = true;
        flush().then(function () { return post('merge', { guest: g }); }).then(function (j) {
          if (j._status !== 200) { say('That did not work. Please try again.'); e.target.disabled = false; return; }
          lsDel('cf-covet:g');
          lsDel('cf-covet-guest');
          bar.remove();
          replaceState(j.state);
          say('Added ' + j.moved + ' item' + (j.moved === 1 ? '' : 's') + ' to your lists.');
          if (pageView) pageView.reload();
        }, function () { say('That did not work. Please try again.'); e.target.disabled = false; });
      }
    });
  }

  // ------------------------------------------------------------ My Coveted Lists and shared list pages
  var pageView = null;
  function bootData() {
    var s = document.getElementById('cf-lists-boot');
    try { return s ? JSON.parse(s.textContent) : {}; } catch (e) { return {}; }
  }

  /**
   * The bulk-code bar (Dan 2026-10-02: at $326 it read "$174 more" beside "BULK15", and the fill sat short of the
   * BULK15 mark because it was drawn on a straight $0-$1,000 scale under evenly spaced marks). Now: the marks sit at
   * even steps and the fill is measured between the two marks around the total; the words name the code already
   * reached and, separately, the next one with the dollars to go. Reached marks get a check and bold (never colour).
   */
  function tierHtml(total, from) {
    var marks = [[0, '', 0]].concat(TIERS), got = null, next = null;
    TIERS.forEach(function (t) { if (total >= t[0]) got = t; else if (!next) next = t; });
    var step = 100 / (marks.length - 1), pct = 100;
    for (var i = 1; i < marks.length; i++) {
      if (total < marks[i][0]) { pct = (i - 1) * step + step * (total - marks[i - 1][0]) / (marks[i][0] - marks[i - 1][0]); break; }
    }
    var words = '<b>' + (from ? 'From ' : '') + money(total) + '</b> list total.';
    if (got) words += ' <b class="cf-code">' + got[1] + '</b> unlocked: code <b class="cf-code">' + got[1] + '</b> takes ' + got[2] + '% off at checkout.';
    if (next) words += ' Add <b>' + money(next[0] - total) + '</b> more for <b class="cf-code">' + next[1] + '</b> (' + next[2] + '% off).';
    else words += ' That is our biggest discount.';
    var ticks = marks.map(function (m, i) {
      var reached = total >= m[0] && i > 0;
      var pos = i === 0 ? 'left:0' : i === marks.length - 1 ? 'right:0' : 'left:' + (i * step) + '%';
      var label = i === 0 ? '$0' : (reached ? '\u2713 ' : '') + '<b class="cf-code">' + m[1] + '</b><br>$' + m[0].toLocaleString('en-US');
      return '<span class="' + (i === 0 ? 'cf-t0' : i === marks.length - 1 ? 'cf-tend' : '') + (reached ? ' cf-reached' : '') + '" style="' + pos + '">' + label + '</span>';
    }).join('');
    return '<div class="cf-tier"><div>' + words + '</div><div class="cf-track" aria-hidden="true"><b style="width:' + pct.toFixed(1) + '%"></b></div>' +
      '<div class="cf-ticks" aria-hidden="true">' + ticks + '</div></div>';
  }
  function priceOf(r, info) {
    if (!info) return null;
    if (r.v) { for (var i = 0; i < (info.vs || []).length; i++) if (info.vs[i].id === r.v) return { n: info.vs[i].pr, from: false, ok: info.vs[i].ok }; return null; }
    return info.mn == null ? null : { n: info.mn, from: info.mx != null && info.mx !== info.mn, ok: true };
  }
  function versionOf(r, info) {
    if (!r.v) return null;
    var vs = (info && info.vs) || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].id === r.v) return variantLabel(vs[i]) || 'Standard';
    return 'Version no longer offered';
  }
  /** "Scale 32mm · Model 5x" from the version's option pairs; its title only until the product cache has them. */
  function variantLabel(v) {
    return v.o && v.o.length ? optionLabel(v.o.map(function (x) { return x[0]; }), v.o.map(function (x) { return x[1]; })) : versionName(v.t);
  }
  function itemsHtml(rows, products, editable) {
    if (!rows.length) return '<p class="cf-empty">' + (editable ? 'Nothing here yet. Tap the heart on any product to save it.' : 'This list is empty.') + '</p>';
    return '<div class="cf-items">' + rows.map(function (r) {
      var info = products[r.p] || {}, local = state.prod[r.p] || {};
      var title = info.t || local.t || 'A product';
      var href = info.h ? '/products/' + info.h + (r.v ? '?variant=' + r.v : '') : null;
      var img = info.i || local.i;
      if (img && /cdn\.shopify\.com/.test(img) && !/[?&]width=/.test(img)) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
      var pr = priceOf(r, info), vn = versionOf(r, info);
      var id = 'cfr-' + r.l + '-' + r.p + '-' + r.v;
      var chips = editable && info.vs && info.vs.length > 1 && r.v ? '' : vn ? vn.split(' · ').map(function (c) { return '<span class="cf-chip">' + esc(c) + '</span>'; }).join('') : '<span class="cf-chip cf-any">Any version</span>';
      var pick = '';
      if (editable && info.vs && info.vs.length > 1) {
        pick = '<label class="visually-hidden" for="' + id + '-v">Version</label><select class="cf-input" id="' + id + '-v" data-cf-row="variant" style="font-size:12px;padding:3px 6px">' +
          (r.v ? '' : '<option value="">Pick a version</option>') +
          info.vs.map(function (v) { return '<option value="' + v.id + '"' + (v.id === r.v ? ' selected' : '') + '>' + esc(variantLabel(v)) + ' - ' + money(v.pr) + (v.ok ? '' : ' (unavailable)') + '</option>'; }).join('') + '</select>';
      }
      var gone = info.gone ? '<span class="cf-chip">No longer available</span> <a href="' + BASE + '" data-cf-askone>Ask about this one</a>' : '';
      var inName = r.inName ? '<span class="cf-meta">in ' + esc(r.inName) + '</span>' : '';
      var right = '<span class="cf-price">' + (pr ? (pr.from ? 'From ' : '') + money(pr.n) : '') + '</span>';
      if (editable) {
        right += '<label class="cf-meta">Qty <input class="cf-input" type="number" min="1" max="999" value="' + r.q + '" data-cf-row="qty" aria-label="Quantity"></label>' +
          '<button type="button" class="cf-link" data-cf-row="note">' + (r.n ? 'Edit note' : 'Add note') + '</button>' +
          '<button type="button" class="cf-link" data-cf-row="remove">Remove</button>';
      } else right += '<span class="cf-meta">Qty ' + r.q + '</span>';
      return '<div class="cf-item" data-l="' + esc(r.l) + '" data-p="' + r.p + '" data-v="' + r.v + '">' +
        (href ? '<a href="' + esc(href) + '" class="cf-thumb" style="background-image:url(\'' + esc(img || '') + '\')" aria-hidden="true" tabindex="-1"></a>' : '<span class="cf-thumb" style="background-image:url(\'' + esc(img || '') + '\')"></span>') +
        '<div>' + (href ? '<a class="cf-title" href="' + esc(href) + '">' + esc(title) + '</a>' : '<span class="cf-title">' + esc(title) + '</span>') +
        '<div class="cf-chips">' + chips + pick + inName + gone + '</div>' + (r.n ? '<div class="cf-note">Note: "' + esc(r.n) + '"</div>' : '') + '</div>' +
        '<div class="cf-right">' + right + '</div></div>';
    }).join('') + '</div>';
  }
  function totals(rows, products) {
    var t = 0, from = false;
    rows.forEach(function (r) { var pr = priceOf(r, products[r.p]); if (pr) { t += pr.n * r.q; if (pr.from) from = true; } });
    return { total: Math.round(t * 100) / 100, from: from };
  }
  /** Rows a cart can take: a real version that is for sale. */
  function addAllToCart(rows, products, btn) {
    var items = [], need = 0, out = 0;
    rows.forEach(function (r) {
      var pr = priceOf(r, products[r.p]);
      if (!r.v) need++;
      else if (!pr || !pr.ok || (products[r.p] || {}).gone) out++;
      else items.push({ id: r.v, quantity: r.q });
    });
    if (!items.length) { say(need ? 'Pick a version for each item first ("Pick a version").' : 'Nothing in this list can go in the cart right now.', 5000); return; }
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; say('The cart did not take these. Please try again.'); });
    if (need || out) say((need ? need + ' item' + (need === 1 ? '' : 's') + ' still need a version. ' : '') + (out ? out + ' not available.' : ''), 5000);
  }

  function MinePage(boot) {
    var products = boot.products || {};
    var current = LIKED;
    var self = this;
    if (boot.owner === 'customer' && boot.state && !queue.length) { state.lists = boot.state.lists; state.items = boot.state.items; ensureLiked(); save(); }
    this.reload = function () {
      flush().then(function () {
        var body = { products: true };
        if (!cid) { var g = guestToken(false); if (!g) { self.draw(); return null; } body.guest = g; } else body.guest = guestToken(false) || undefined;
        return post('state', body);
      }).then(function (j) {
        if (!j) return;
        if (j._status !== 200) { pageEl.innerHTML = '<p class="cf-empty">Lists are taking a nap. Your hearts are saved on this device; try again in a few minutes.</p>'; return; }
        products = j.products || {};
        replaceState(j.state);
        if (j.guestItems > 0) offerMerge(j.guestItems);
        self.draw();
      }, function () { pageEl.innerHTML = '<p class="cf-empty">Lists are taking a nap. Your hearts are saved on this device; try again in a few minutes.</p>'; });
    };
    function rowsFor(k) {
      var ks = [k].concat(kids(k).map(function (c) { return c.k; }));
      return state.items.filter(function (i) { return ks.indexOf(i.l) >= 0; }).map(function (i) {
        var copy = {}; for (var x in i) copy[x] = i[x];
        if (i.l !== k) { var l = list(i.l); copy.inName = l ? l.n : ''; }
        return copy;
      });
    }
    function count(k) { var seen = {}; rowsFor(k).forEach(function (r) { seen[r.p + ':' + r.v] = 1; }); return Object.keys(seen).length; }
    this.draw = function () {
      if (!list(current)) current = LIKED;
      var l = list(current), rows = rowsFor(current), subs = kids(current), t = totals(rows, products);
      var side = '';
      topLists().forEach(function (x) {
        side += sideBtn(x, false);
        kids(x.k).forEach(function (c) { side += sideBtn(c, true); });
      });
      side += '<button type="button" class="cf-new" data-cf-page="new">+ New list</button>';
      function sideBtn(x, sub) { return '<button type="button"' + (sub ? ' class="cf-sub"' : '') + ' data-cf-page="open" data-k="' + esc(x.k) + '"' + (x.k === current ? ' aria-current="true"' : '') + '>' + esc(x.n) + ' <span>' + count(x.k) + '</span></button>'; }
      var models = rows.reduce(function (s, r) { return s + r.q; }, 0);
      var meta = models + ' item' + (models === 1 ? '' : 's') + (subs.length ? ' · ' + subs.length + ' sub-list' + (subs.length === 1 ? '' : 's') : '') + ' · ' + (l.sh && l.sh.on ? 'Shared by link' : 'Private');
      var signIn = cid ? '' : '<p class="cf-meta">Saved on this device. <a href="' + esc(pageEl.getAttribute('data-login') || '/account/login') + '">Sign in</a> to keep your lists on every device.</p>';
      var head = '<div class="cf-head"><div><h2>' + esc(l.n) + '</h2><div class="cf-meta">' + meta + ' ' + saveHtml() + '</div></div><div class="cf-actions" style="margin:0">' +
        (current === LIKED ? '' : '<button type="button" class="cf-btn cf-ghost cf-small" data-cf-page="rename">Rename</button>' +
          (subs.length ? '' : '<button type="button" class="cf-btn cf-ghost cf-small" data-cf-page="move">' + (l.par ? 'Move out' : 'Put inside...') + '</button>') +
          '<button type="button" class="cf-btn cf-ghost cf-small" data-cf-page="delete">Delete list</button>') + '</div></div>';
      pageEl.innerHTML = signIn + '<div class="cf-lp"><nav class="cf-side" aria-label="My lists">' + side + '</nav><section aria-live="polite">' + head +
        (rows.length ? tierHtml(t.total, t.from) : '') + itemsHtml(rows, products, true) +
        '<div class="cf-actions"><button type="button" class="cf-btn" data-cf-page="cart"' + (rows.length ? '' : ' disabled') + '>Add all to cart</button>' +
        '<button type="button" class="cf-btn cf-ghost" data-cf-page="share">Share</button>' +
        '<button type="button" class="cf-btn cf-ghost" data-cf-page="quote">Ask for a quote</button></div>' +
        (rows.some(function (r) { return !r.v; }) ? '<p class="cf-meta">"Any version" items need a version before they go in the cart.</p>' : '') +
        '</section></div>';
    };

    pageEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cf-page],[data-cf-row],[data-cf-askone]');
      if (!b) return;
      if (b.hasAttribute('data-cf-askone')) { e.preventDefault(); quoteModal(list(current), rowsFor(current)); return; }
      var a = b.getAttribute('data-cf-page'), rowA = b.getAttribute('data-cf-row');
      if (a === 'open') { current = b.getAttribute('data-k'); self.draw(); var cur = pageEl.querySelector('[aria-current="true"]'); if (cur) cur.focus(); return; }
      if (a === 'new') return nameModal('New list', '', function (name) { if (state.lists.length >= 50) { say('You have 50 lists, the most we keep.'); return; } var k = randomKey(10); op({ t: 'list', l: k, name: name, parent: null }); current = k; self.draw(); });
      if (a === 'rename') { var l0 = list(current); return nameModal('Rename list', l0.n, function (name) { op({ t: 'list', l: current, name: name, parent: l0.par }); }); }
      if (a === 'delete') return confirmModal('Delete "' + list(current).n + '"?', 'Its items are removed from this list (they stay in your other lists). Sub-lists move to the top.', 'Delete list', function () { op({ t: 'dellist', l: current }); current = LIKED; self.draw(); });
      if (a === 'move') return moveModal();
      if (a === 'cart') return addAllToCart(rowsFor(current), products, b);
      if (a === 'share') return shareModal(list(current));
      if (a === 'quote') return quoteModal(list(current), rowsFor(current));
      var it = b.closest('.cf-item');
      if (!it || !rowA) return;
      var key = { l: it.getAttribute('data-l'), p: Number(it.getAttribute('data-p')), v: Number(it.getAttribute('data-v')) };
      if (rowA === 'remove') { op({ t: 'remove', l: key.l, p: key.p, v: key.v }); say('Removed.'); }
      if (rowA === 'note') { var r0 = row(key.l, key.p, key.v); nameModal('Note', r0 ? r0.n : '', function (n) { op({ t: 'note', l: key.l, p: key.p, v: key.v, n: n }); }, true); }
    });
    pageEl.addEventListener('change', function (e) {
      var b = e.target, rowA = b.getAttribute('data-cf-row'), it = b.closest('.cf-item');
      if (!it || !rowA) return;
      var key = { l: it.getAttribute('data-l'), p: Number(it.getAttribute('data-p')), v: Number(it.getAttribute('data-v')) };
      if (rowA === 'qty') { var q = Math.max(1, Math.min(999, Math.floor(Number(b.value) || 1))); op({ t: 'qty', l: key.l, p: key.p, v: key.v, q: q }); }
      if (rowA === 'variant' && b.value) op({ t: 'variant', l: key.l, p: key.p, v: key.v, nv: Number(b.value) });
    });

    function moveModal() {
      var l = list(current);
      if (l.par) { op({ t: 'list', l: current, name: l.n, parent: null }); say('Moved to the top.'); return; }
      var options = topLists().filter(function (x) { return x.k !== LIKED && x.k !== current; });
      if (!options.length) { say('Make another list first, then put this one inside it.'); return; }
      modal('Put "' + esc(l.n) + '" inside', '<label>List<select class="cf-input" data-f="par">' + options.map(function (x) { return '<option value="' + esc(x.k) + '">' + esc(x.n) + '</option>'; }).join('') + '</select></label>' +
        '<div class="cf-actions"><button type="button" class="cf-btn" data-ok>Move</button></div>', function (m) {
        m.querySelector('[data-ok]').addEventListener('click', function () { op({ t: 'list', l: current, name: l.n, parent: m.querySelector('[data-f=par]').value }); m.close(); });
      });
    }
    this.draw();
  }

  function SharedPage(boot) {
    if (boot.missing || !boot.list) { pageEl.innerHTML = '<p class="cf-empty">This list is no longer shared. Ask the person who sent it for a new link.</p>'; return; }
    var L = boot.list, products = boot.products || {};
    var t = totals(L.items, products);
    this.draw = function () { /* a shared list does not change with our hearts */ };
    pageEl.innerHTML = (L.by ? '<p class="cf-meta">' + esc(L.by) + ' shared a list with you</p>' : '<p class="cf-meta">A list shared with you</p>') +
      '<h2>' + esc(L.name) + '</h2>' + (L.items.length ? tierHtml(t.total, t.from) : '') + itemsHtml(L.items, products, false) +
      '<div class="cf-actions"><button type="button" class="cf-btn" data-s="cart"' + (L.items.length ? '' : ' disabled') + '>Add all to cart</button>' +
      '<button type="button" class="cf-btn cf-ghost" data-s="copy"' + (L.items.length ? '' : ' disabled') + '>Copy to my lists</button></div>';
    pageEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s]');
      if (!b) return;
      if (b.getAttribute('data-s') === 'cart') addAllToCart(L.items, products, b);
      if (b.getAttribute('data-s') === 'copy') {
        if (state.lists.length >= 50) { say('You have 50 lists, the most we keep.'); return; }
        var k = randomKey(10);
        op({ t: 'list', l: k, name: L.name.slice(0, 60), parent: null });
        L.items.forEach(function (r) { op({ t: 'add', l: k, p: r.p, v: r.v, q: r.q, from: 'copy' }); });
        L.items.forEach(function (r) { var info = products[r.p]; if (info) state.prod[r.p] = { t: info.t, h: info.h, i: info.i, pr: info.mn }; });
        save();
        b.disabled = true;
        say('Copied to your lists. <a href="' + BASE + '">See my lists</a>', 6000);
      }
    });
  }

  // ------------------------------------------------------------ dialogs
  function modal(title, inner, wire) {
    var back = document.createElement('div');
    back.className = 'cf-modal-back';
    back.innerHTML = '<div class="cf-modal" role="dialog" aria-modal="true" aria-label="' + esc(title.replace(/<[^>]+>/g, '')) + '"><button type="button" class="cf-close cf-link" style="position:absolute;top:10px;right:14px;font-size:22px;text-decoration:none" aria-label="Close" data-x>&times;</button><h3>' + title + '</h3>' + inner + '</div>';
    var ret = document.activeElement;
    document.body.appendChild(back);
    var m = back.querySelector('.cf-modal');
    m.close = function () { back.remove(); document.removeEventListener('keydown', esc1, true); if (ret && ret.focus) try { ret.focus(); } catch (e) { /* gone */ } };
    function esc1(e) { if (e.key === 'Escape') { e.preventDefault(); m.close(); } }
    document.addEventListener('keydown', esc1, true);
    back.addEventListener('click', function (e) { if (e.target === back || e.target.hasAttribute('data-x')) m.close(); });
    wire(m);
    var f = m.querySelector('input:not([type=hidden]):not(.cf-hp input),textarea,select,button:not([data-x])');
    if (f) f.focus();
    return m;
  }
  function nameModal(title, value, done, long) {
    modal(esc(title), (long ? '<label>Note<textarea class="cf-input" maxlength="300" data-f="v">' + esc(value) + '</textarea></label>' : '<label>Name<input class="cf-input" maxlength="60" data-f="v" value="' + esc(value) + '"></label>') +
      '<div class="cf-actions"><button type="button" class="cf-btn" data-ok>Save</button></div>', function (m) {
      var input = m.querySelector('[data-f=v]');
      function ok() { var v = input.value.trim(); if (!v && !long) return; done(v); m.close(); }
      m.querySelector('[data-ok]').addEventListener('click', ok);
      if (!long) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ok(); } });
    });
  }
  function confirmModal(title, text, label, done) {
    modal(esc(title), '<p style="margin:0">' + esc(text) + '</p><div class="cf-actions"><button type="button" class="cf-btn" data-ok>' + esc(label) + '</button><button type="button" class="cf-btn cf-ghost" data-x>Cancel</button></div>', function (m) {
      m.querySelector('[data-ok]').addEventListener('click', function () { done(); m.close(); });
    });
  }
  function shareModal(l) {
    modal('Share "' + esc(l.n) + '"', '<div class="cf-switch"><span>Link sharing is <b data-f="state">' + (l.sh && l.sh.on ? 'ON' : 'OFF') + '</b></span></div>' +
      '<label>Anyone with this link can view it<input class="cf-input" readonly data-f="url" value="' + (l.sh && l.sh.on && l.sh.t ? esc(location.origin + BASE + '/s/' + l.sh.t) : '') + '" placeholder="Turn the link on to get it"></label>' +
      '<label>Show my name as (optional)<input class="cf-input" maxlength="40" data-f="name" value="' + esc((l.sh && l.sh.nm) || pageEl.getAttribute('data-first') || '') + '"></label>' +
      '<div class="cf-actions" style="margin:0"><button type="button" class="cf-btn cf-small" data-f="on">' + (l.sh && l.sh.on ? 'Copy link' : 'Turn on and copy link') + '</button>' +
      '<button type="button" class="cf-btn cf-ghost cf-small" data-f="off"' + (l.sh && l.sh.on ? '' : ' hidden') + '>Turn off link</button></div>' +
      '<p class="cf-meta" style="margin:0">Friends can view it, add it to their cart, or copy it into their own lists. They cannot change yours.</p>', function (m) {
      function go(on, btn) {
        btn.disabled = true;
        flush().then(function () {
          var w = who(), body = { as: w.as, l: l.k, on: on, name: m.querySelector('[data-f=name]').value.trim() };
          if (w.cid) body.cid = w.cid;
          if (w.guest) body.guest = w.guest;
          return post('share', body);
        }).then(function (j) {
          btn.disabled = false;
          if (j._status !== 200) { say(j.error || 'Sharing did not work. Please try again.'); return; }
          l.sh = { on: j.on, t: j.token, nm: m.querySelector('[data-f=name]').value.trim() || null };
          save();
          m.querySelector('[data-f=state]').textContent = j.on ? 'ON' : 'OFF';
          m.querySelector('[data-f=url]').value = j.on ? j.url : '';
          m.querySelector('[data-f=off]').hidden = !j.on;
          m.querySelector('[data-f=on]').textContent = j.on ? 'Copy link' : 'Turn on and copy link';
          if (j.on) {
            var copied = navigator.clipboard ? navigator.clipboard.writeText(j.url) : Promise.reject();
            copied.then(function () { say('Link copied.'); }, function () { m.querySelector('[data-f=url]').select(); say('Copy the link from the box.'); });
          } else say('Link turned off. Anyone with the old link now sees nothing.');
          if (pageView) pageView.draw();
        }, function () { btn.disabled = false; say('Sharing needs a connection. Please try again.'); });
      }
      m.querySelector('[data-f=on]').addEventListener('click', function (e) { go(true, e.target); });
      m.querySelector('[data-f=off]').addEventListener('click', function (e) { go(false, e.target); });
    });
  }
  var TICKS = ['Different scale', 'Bigger quantity', 'Custom parts or kitbash', 'Something not listed'];
  function quoteModal(l, rows) {
    var models = rows.reduce(function (s, r) { return s + r.q; }, 0);
    modal('Get a quote for "' + esc(l.n) + '"' + (models ? ' (' + models + ' item' + (models === 1 ? '' : 's') + ')' : ''),
      '<div><span>What would you like changed? Tick any.</span><div class="cf-tickrow" style="margin-top:6px">' +
      TICKS.map(function (t, i) { return '<label><input type="checkbox" data-tick value="' + esc(t) + '" id="cft' + i + '"><span>' + esc(t) + '</span></label>'; }).join('') + '</div></div>' +
      '<label>Tell us more<textarea class="cf-input" maxlength="2000" data-f="note" placeholder="For example: the whole army at 28mm, 20 of the knights"></textarea></label>' +
      '<label>Your name (optional)<input class="cf-input" maxlength="80" data-f="cname" value="' + esc(pageEl.getAttribute('data-first') || '') + '"></label>' +
      '<label>Email for the quote<input class="cf-input" type="email" required maxlength="200" data-f="email" value="' + esc(pageEl.getAttribute('data-email') || '') + '"></label>' +
      '<div class="cf-hp" aria-hidden="true"><label>Website<input tabindex="-1" autocomplete="off" data-f="website"></label></div>' +
      '<label class="cf-inline"><input type="checkbox" data-f="ok" checked> OK to email me about this quote</label>' +
      '<div class="cf-actions" style="margin:0"><button type="button" class="cf-btn" data-ok>Send to Coveted Forge</button></div>', function (m) {
      m.querySelector('[data-ok]').addEventListener('click', function (e) {
        var btn = e.target, email = m.querySelector('[data-f=email]').value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) { say('Please give an email we can answer.'); m.querySelector('[data-f=email]').focus(); return; }
        if (!m.querySelector('[data-f=ok]').checked) { say('Please tick "OK to email me" so we can send the quote.'); return; }
        btn.disabled = true;
        var body = {
          list: l.n, email: email, cname: m.querySelector('[data-f=cname]').value.trim(), note: m.querySelector('[data-f=note]').value.trim(), ok: true,
          website: m.querySelector('[data-f=website]').value,
          ticks: Array.prototype.map.call(m.querySelectorAll('[data-tick]:checked'), function (x) { return x.value; }),
          items: rows.map(function (r) { return { p: r.p, v: r.v, q: r.q, n: r.n || undefined }; }),
        };
        if (!cid) body.guest = guestToken(true);
        post('quote', body).then(function (j) {
          if (j._status !== 200) { btn.disabled = false; say(j.error || 'That did not send. Please try again.', 6000); return; }
          m.innerHTML = '<h3>Quote request sent</h3><p style="margin:0">Dan or Verka will email you, usually within one business day. We saved a copy of the list as it is now.</p>' +
            '<div class="cf-actions" style="margin:0"><button type="button" class="cf-btn cf-ghost cf-small" data-x>Back to my lists</button></div>';
          m.querySelector('[data-x]').addEventListener('click', function () { m.close(); });
          m.querySelector('[data-x]').focus();
        }, function () { btn.disabled = false; say('That did not send. Please check your connection and try again.'); });
      });
    });
  }

  // ------------------------------------------------------------ start
  function start() {
    mo.observe(document.body, { childList: true, subtree: true });
    if (pageEl) {
      var boot = bootData();
      pageView = pageEl.getAttribute('data-mode') === 'shared' ? new SharedPage(boot) : new MinePage(boot);
      if (pageEl.getAttribute('data-mode') !== 'shared' && (boot.owner !== 'customer' || queue.length || guestToken(false))) pageView.reload();
      if (cid) ssSet('cf-covet-synced-' + cid, '1');
    }
    drawAll();
    if (queue.length) flushSoon(1500);
    syncOnce();
  }
  window.CFCovet = { loaded: true, state: function () { return state; }, flush: flush, BASE: BASE };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
